import Upload from './Upload';
import './style/index.less';
export type { UploadRef } from './Upload';
export default Upload;
